import { Button, Chip, Grid } from "@mui/material";
import Modal from "../../../../components/Modal/Modal";
import SimpleBackdrop from "../../../../components/Loading/SimpleBackdrop";
import { useEffect, useState } from "react";
import InputLabel from "../../../../components/Inputs/InputLabel";
import { formatDate } from "../../../../utilities/date";
import SelectSimple from "../../../../components/Selects/SelectSimple";
import { converterMoeda, displayMoney } from "../../../../utilities/displayValues";
import moment from "moment";
import { AlertConfirm, AlertInfo } from "../../../../components/Alerts/Alert";
import { api } from "../../../../services/api";
import { ContasPagarType } from "../../../../types/ContasPagarType";
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import EventBusyIcon from '@mui/icons-material/EventBusy';
import CheckIcon from '@mui/icons-material/Check';

type CadApagarType = {
    open: boolean,
    setOpen: React.Dispatch<React.SetStateAction<boolean>>
    conta: ContasPagarType | null,
    setConta: React.Dispatch<React.SetStateAction<ContasPagarType | null>>
    reload: () => void,
}

export default function CadApagar({ open, setOpen, conta, setConta, reload }: CadApagarType) {
    const [openLoad, setOpenLoad] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [destinatario_conta, setDestinatarioConta] = useState("");
    const [descricao_adicional_conta, setDescricaoAdicionalConta] = useState("");
    const [categoria_conta, setCategoriaConta] = useState<string | number>("");
    const [status_conta, setStatusConta] = useState(1);
    const [valor_pagar, setValorPagar] = useState("");
    const [valor_pago, setValorPago] = useState("");
    const [data_emissao, setDataEmissao] = useState(formatDate(new Date(), "usd"));
    const [data_vencimento, setDataVencimento] = useState("");
    const [data_pagamento, setDataPagamento] = useState("");

    function clearForm() {
        setDestinatarioConta("");
        setDescricaoAdicionalConta("");
        setCategoriaConta("");
        setStatusConta(1);
        setValorPagar("");
        setValorPago("");
        setDataEmissao(formatDate(new Date(), "usd"));
        setDataVencimento("");
        setDataPagamento("");

        setConta(null);
    }

    async function handleSave() {
        if (openLoad) return;
        const data = {
            destinatario_conta: destinatario_conta.toUpperCase(),
            descricao_adicional_conta: descricao_adicional_conta.toUpperCase(),
            categoria_conta, data_emissao, data_vencimento,
            valor_pagar: converterMoeda(valor_pagar),
            status_conta: moment(data_vencimento).isBefore(moment()) ? 'EM ATRASO' : 'A VENCER',
        };
        if (data.destinatario_conta.length < 3) return AlertInfo({ icon: 'error', title: "Destinatario da conta invalido" });
        if (!moment(data.data_emissao).isValid()) return AlertInfo({ icon: 'error', title: "Data da emissão invalida" });
        if (!moment(data.data_vencimento).isValid()) return AlertInfo({ icon: 'error', title: "Data de vencimento invalida" });
        if (isNaN(data.valor_pagar) || data.valor_pagar <= 0) return AlertInfo({ icon: 'error', title: "Valor a pagar invalido" });
        setOpenLoad(true);
        try {
            const url = conta && conta.id_conta_pagar ? `/updatecontapagar/${conta.id_conta_pagar}` : `/createcontapagar`;
            const response = await api.post(url, data);
            if (response.data.success) {
                AlertInfo({ icon: 'success', title: 'Dados Gravados' }).then(() => {
                    setOpenLoad(true);
                    setOpen(false);
                    reload();
                });
            } else {
                console.log(response);
                AlertInfo({ icon: 'error', title: response.data.error || "Falha na operação" });
                setOpenLoad(false);
            }
        } catch (error) {
            console.log(error);
            setOpenLoad(false);
        }
    }

    function ChipStatus({ cod = 1 }) {
        if (cod === 2) return <Chip label="EM ATRASO" color="error" icon={<EventBusyIcon />} sx={{ width: '100%' }} />
        if (cod === 3) return <Chip label="PAGA" color="success" icon={<CheckIcon />} sx={{ width: '100%' }} />
        return <Chip label="A VENCER" color="primary" icon={<CalendarMonthIcon />} sx={{ width: '100%' }} />
    }

    function handleDelete() {
        if (conta && conta.id_conta_pagar) {
            AlertConfirm({ title: 'DELETAR CONTA?', text: 'A Ação não poderá ser desfeita' }).then(async res => {
                if (res.isConfirmed) {
                    if (openLoad) return;
                    setOpenLoad(true);
                    try {
                        const response = await api.post(`/updatecontapagar/${conta.id_conta_pagar}`, { conta_pagar_ativa: 0 });
                        if (response.data.success) {
                            AlertInfo({ icon: 'success', title: 'Conta Deletada' }).then(() => {
                                setOpenLoad(true);
                                setOpen(false);
                                reload();
                            });
                        } else {
                            AlertInfo({ icon: 'error', title: response.data.error || "Falha na operação" });
                            setOpenLoad(false);
                        }
                    } catch (error) {
                        console.log(error);
                        setOpenLoad(false);
                    }
                }
            });
        }
    }

    async function handlePague() {
        //
    }

    function editConta() {
        if (conta && conta.id_conta_pagar) {
            setDestinatarioConta(conta.destinatario_conta);
            setDescricaoAdicionalConta(conta.descricao_adicional_conta);
            setCategoriaConta(conta.categoria_conta);
            setStatusConta(conta.status_conta);
            setValorPagar(displayMoney(conta.valor_pagar));
            setValorPago(displayMoney(conta.valor_pago));
            setDataEmissao(formatDate(conta.data_emissao, "usd"));
            setDataVencimento(formatDate(conta.data_vencimento, "usd"));
            setDataPagamento(formatDate(conta.data_pagamento, "usd"));
        }
    }

    useEffect(() => {
        editConta();
    }, [conta]);

    return (
        <Modal
            open={open}
            setOpen={setOpen}
            title="Cadastro de Conta a Pagar"
            maxWidth="md"
            zIndex={2222}
            actionClose={clearForm}
        >
            <Modal
                open={openModal}
                setOpen={setOpenModal}
                title="Efetuar Pagamento"
                maxWidth="xs"
                zIndex={3333}
            >
                <Grid container spacing={1}>
                    <Grid item xs={12}>
                        <InputLabel
                            label="Data Pagamento"
                            type="date"
                            value={data_pagamento}
                            setState={setDataPagamento}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <InputLabel
                            id="valor_pago"
                            label="Valor Pago"
                            value={valor_pago}
                            setState={setValorPago}
                            isMoney
                            isSelectText
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <Button
                            variant="contained"
                            fullWidth
                            color="success"
                            onClick={handlePague}
                        >
                            PAGAR
                        </Button>
                    </Grid>
                </Grid>
            </Modal>

            <Grid container spacing={1}>
                <SimpleBackdrop open={openLoad} />
                {conta && conta.id_conta_pagar && (
                    <>
                        <Grid item xs={12} sm={3}>
                            <ChipStatus cod={conta.status_conta} />
                        </Grid>
                        <Grid item xs={12} sm={7}></Grid>
                        <Grid item xs={12} sm={2}>
                            <Button
                                variant="contained"
                                fullWidth
                                color="error"
                                onClick={handleDelete}
                            >
                                DELETAR
                            </Button>
                        </Grid>
                    </>
                )}
                <Grid item xs={12} sm={6}>
                    <InputLabel
                        label="Destinatario da Conta"
                        value={destinatario_conta}
                        setState={setDestinatarioConta}
                        next="descricao_adicional_conta"
                        isUpper
                        autoFocus
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <InputLabel
                        id="descricao_adicional_conta"
                        label="Descrição Adicional"
                        value={descricao_adicional_conta}
                        setState={setDescricaoAdicionalConta}
                        next="categoria_conta"
                        isUpper
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <SelectSimple
                        id="categoria_conta"
                        label="Categoria"
                        value={categoria_conta}
                        setState={setCategoriaConta}
                        options={[]}
                        isNone
                        next="data_emissao"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <InputLabel
                        id="data_emissao"
                        type="date"
                        label="Data da Emissão"
                        value={data_emissao}
                        setState={setDataEmissao}
                        next="data_vencimento"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <InputLabel
                        id="data_vencimento"
                        type="date"
                        label="Data de Vencimento"
                        value={data_vencimento}
                        setState={setDataVencimento}
                        next="valor_pagar"
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    <InputLabel
                        id="valor_pagar"
                        label="Valor a Pagar"
                        value={valor_pagar}
                        setState={setValorPagar}
                        isMoney
                    />
                </Grid>
                <Grid item xs={12} sm={3}>
                    {conta && conta.data_pagamento && (
                        <Chip label={moment(conta.data_pagamento).format('DD/MM/YYYY')} />
                    )}
                </Grid>
                <Grid item xs={false} sm={4}></Grid>
                <Grid item xs={12} sm={2}>
                    {conta && conta.status_conta !== 3 && (
                        <Button
                            variant="contained"
                            fullWidth
                            color="success"
                            onClick={() => setOpenModal(true)}
                        >
                            PAGAR
                        </Button>
                    )}
                </Grid>

                <Grid item xs={false} sm={4}></Grid>
                <Grid item xs={12} sm={4}>
                    <Button
                        variant="contained"
                        fullWidth
                        color="success"
                        onClick={handleSave}
                    >
                        SALVAR
                    </Button>
                </Grid>
                <Grid item xs={false} sm={4}></Grid>
            </Grid>
        </Modal>
    );
}